<div class="tune-in-button" *ngIf="uid && uid !== userUid">
    <button mat-raised-button [ngClass]="{'tune-in-button__small': size === 'small'}" color="primary" *ngIf="!tunedIn && buttonReady" (click)="tuneIn()">Tune in</button>
    <button mat-raised-button [ngClass]="{'tune-in-button__small': size === 'small'}" *ngIf="tunedIn && buttonReady" (click)="tuneOut()">Tuned in</button>
</div>
<div *ngIf="!uid">
    <button mat-raised-button [ngClass]="{'tune-in-button__small': size === 'small'}" color="primary" (click)="openAuthRequired('tuneIn')">Tune in</button>
</div>